import LineService from '@/common/api/line'
import {
  GET_OAUTH,
  GET_OAUTH_TOP,
  LINE_REGISTRATION,
  LINE_PROFILE_REGISTRATION,
  LINE_NO_PROFILE_REGISTRATION,
  LINE_LIFF_PROFILE_REGISTRATION,
  LINE_LIFF_NO_PROFILE_REGISTRATION,
  LINE_TOP_REGISTRATION
} from './actions'
import {
} from './mutations'

const state = {
}

const getters = {
}

const actions = {
  [GET_OAUTH] (context, params = {}) {
    return new Promise((resolve, reject) => {
      LineService.OAuth(params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  [GET_OAUTH_TOP] (context, params = {}) {
    return new Promise((resolve, reject) => {
      LineService.OAuthTop(params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  [LINE_REGISTRATION] (context, params = {}) {
    return new Promise((resolve, reject) => {
      LineService.lineRegistration(params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  [LINE_PROFILE_REGISTRATION] (context, params = {}) {
    return new Promise((resolve, reject) => {
      LineService.lineProfileRegistration(params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  [LINE_NO_PROFILE_REGISTRATION] (context, params = {}) {
    return new Promise((resolve, reject) => {
      LineService.lineNoProfileRegistration(params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  [LINE_LIFF_PROFILE_REGISTRATION] (context, params = {}) {
    return new Promise((resolve, reject) => {
      LineService.lineLiffProfileRegistration(params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  [LINE_LIFF_NO_PROFILE_REGISTRATION] (context, params = {}) {
    return new Promise((resolve, reject) => {
      LineService.lineLiffNoProfileRegistration(params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  [LINE_TOP_REGISTRATION] (context, params = {}) {
    return new Promise((resolve, reject) => {
      LineService.lineTopRegistration(params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const mutations = {
}

export default {
  state,
  getters,
  actions,
  mutations
}
